import { getTenant } from '../../tenant-support/get-tenant';
import { configuration } from '../../configuration';
import { authenticationCredentials, authenticationHeaders } from '../../authentication/bff-session';
import { GetPromptRequest, GetCitizenAssistantPromptRequest } from './auto-generated-clients';

export type IPrompt = GetPromptRequest | GetCitizenAssistantPromptRequest;
export function getPrompt(input: GetPromptRequest, token: string | undefined) {
  const headers = {
    'Content-Type': 'application/json',
    'X-Tenant': getTenant().name,
    Accept: 'application/octet-stream',
    ...authenticationHeaders(token),
  };

  const body = JSON.stringify(input);

  const response = fetch(`${configuration.bffBaseAddress}/aisearch/queries/getprompt`, {
    method: 'POST',
    credentials: authenticationCredentials(),
    headers,
    body,
  });

  return response;
}

export function getCitizenPrompt(input: IPrompt, token: string | undefined) {
  const headers = {
    'Content-Type': 'application/json',
    'X-Tenant': getTenant().name,
    Accept: 'text/event-stream',
    ...authenticationHeaders(token),
    'Cache-Control': 'no-cache',
  };

  const body = JSON.stringify(input);

  const response = fetch(`${configuration.bffBaseAddress}/aisearch/queries/GetCitizenAssistantPrompt`, {
    method: 'POST',
    credentials: authenticationCredentials(),
    headers,
    body,
  });

  return response;
}

export function getPromptTemplate(template: string, templateArguments: any, token: string | undefined) {
  const headers = {
    'Content-Type': 'application/json',
    'X-Tenant': getTenant().name,
    ...authenticationHeaders(token),
  };

  const body = JSON.stringify({
    template,
    arguments: templateArguments,
  });

  const response = fetch(`${configuration.bffBaseAddress}/aisearch/queries/getprompttemplate`, {
    method: 'POST',
    credentials: authenticationCredentials(),
    headers,
    body,
  });

  return response;
}
